import React from "react";
import firebase from "../../components/Firebase.js";

export default function useFirestore() {
  const firestore = React.useMemo(() => firebase.firestore(), []);
  return firestore;
}
